// @flow
import { makeStyles } from "@material-ui/core/styles";
export default makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    overflowY: "auto"
  }
}), { index: 1 });